import PrescriptionModal from "./PrescriptionModal";

export default PrescriptionModal;